import { useEffect, useState } from "react";
import { getMediaBlob } from "../services/db/mediaRepo";

interface BlobImageProps {
  blobKey: string | undefined;
  alt: string;
  className?: string;
  loading?: "lazy" | "eager";
}

export function BlobImage({
  blobKey,
  alt,
  className,
  loading = "lazy"
}: BlobImageProps): JSX.Element {
  const [url, setUrl] = useState<string>();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let revoked = false;
    let objectUrl: string | undefined;
    setFailed(false);
    setUrl(undefined);
    if (!blobKey) {
      return undefined;
    }
    void getMediaBlob(blobKey)
      .then((record) => {
        if (!record || revoked) {
          setFailed(true);
          return;
        }
        objectUrl = URL.createObjectURL(record.blob);
        setUrl(objectUrl);
      })
      .catch(() => setFailed(true));
    return () => {
      revoked = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [blobKey]);

  if (!blobKey || failed) {
    return <span className={className} aria-label={alt} />;
  }
  if (!url) {
    return <span className={className} aria-label={`${alt} loading`} />;
  }
  return <img className={className} src={url} alt={alt} loading={loading} decoding="async" />;
}
